export function minimumLengthRule(min) {
    return function (input) { return input.length >= min || min + "\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"; };
}
//# sourceMappingURL=minimum-length.js.map